import AppSelectorMixin from '../../components/AppSelector/mixins/AppSelectorMixin.js'

export default {
  name: 'AppSelectorMobile',
  mixins: [AppSelectorMixin],
  methods: {
    trackerTypesMobile () {
      const trackersMobile = []
      Object.values(this.authorizedApplications).forEach(application => {
        if (application.trackerTypes) {
          Object.entries(application.trackerTypes).forEach(([key, value]) => {
            if (value.dataTable && value.dataTable.mobile) {
              trackersMobile.push(key)
            }
          })
        }
      })
      return [...new Set(trackersMobile)]
    },
    authorizedApplicationsMobile () {
      const mobileApplications = []

      Object.values(this.authorizedApplications).forEach(application => {
        const disabledWorkspaceCount = this.authorizedWorkspacesMobile(application.id)
          .filter(workspace => workspace.disabled === true)
          .length

        const hasEnabledWorkspaces = application.workspaces !== undefined && disabledWorkspaceCount !== this.authorizedWorkspacesMobile(application.id).length

        if (hasEnabledWorkspaces) {
          mobileApplications.push(application)
        }
      })
      sessionStorage.setItem('authorizedAppsMobile', JSON.stringify(mobileApplications))
      return mobileApplications
    },

    authorizedWorkspacesMobile (applicationId) {
      const workspacesTrackers = Object.values(this.authorizedWorkspaces(applicationId))
      workspacesTrackers.forEach(workSpace => {
        workSpace.disabled = !this.trackerTypesMobile().some(tracker => {
          if (workSpace.trackers !== undefined) {
            return workSpace.trackers.includes(tracker)
          }
        }
        )
      })
      return workspacesTrackers
    }
  }
}
